<div class="dialog-header">
  <h2>Edit Sales Representative</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Sales Representative</label>
    <select [(ngModel)]="selectedRep">
      <option *ngFor="let rep of representatives" [value]="rep.value">
        {{ rep.label }}
      </option>
    </select>
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
